module.exports = __webpack_public_path__ + "assessment.8v2502Yo.svg";